export const GROUP_ID = "G0PZG1KTR7";
export const GROUP_DOMAIN = "11plus.vingle.network";
export const CALENDAR_CHANNEL_ID = "I9EDI5J4L";
export const HOME_CHANNEL_NAME = "I8CET88B8";
export const MATCH_FORUM_ID = "QOE234JTB";
export const THREAD_ID = "T3ZXAG59O";
